import { useContext } from 'react';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

import { ModalContext, SIZES } from './context';

function ModalTitle({ className, ...props }: DialogPrimitive.DialogTitleProps) {
  const { size } = useContext(ModalContext);

  return (
    <DialogPrimitive.DialogTitle
      {...props}
      className={twMerge('m-0 flex items-center bg-blue-500 ', SIZES[size].title, 'font-bold text-white', className)}
    />
  );
}

export { ModalTitle };
